/*
auto-generated by: https://github.com/react-spring/gltfjsx
*/

import React, { useRef } from "react";
import { useLoader, useFrame } from "react-three-fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { draco } from "drei";
import { useAssets } from "./store";

function Heart(props) {
  const mesh = useRef();
  const { nodes } = useLoader(GLTFLoader, "/heart.glb", draco("/draco-gltf/"));
  const fiveTone = useAssets((s) => s.fiveTone);

  useFrame(function ({ clock }) {
    const h = 1 - Math.sin(10 * clock.elapsedTime) / 8;
    const v = 1 + Math.sin(10 * clock.elapsedTime) / 10;

    mesh.current.position.y = Math.sin(clock.elapsedTime * 10) * 0.01;

    mesh.current.scale.x = h;
    mesh.current.scale.z = h;
    mesh.current.scale.y = v;
  });

  return (
    <group {...props} dispose={null}>
      <mesh ref={mesh} geometry={nodes.Love.geometry}>
        <meshToonMaterial
          attach="material"
          color={0xff0000}
          shininess={0}
          specular={0xffffff}
          gradientMap={fiveTone}
        />
      </mesh>
    </group>
  );
}

export default Heart;
